import { useContext } from "react";
import { Badge, Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { useHistory } from "react-router";
import { DataStoreContext, gameActiveSetter, inviteFailedSetter, inviteUsernameSetter, waitingForPlayerSetter } from "../DataStore/DataStore";
import { sendSocket } from "../Socket/SocketManager";

export var setOnlineUserDataList: any;

export function MainPage() {

  const dataStore = useContext(DataStoreContext);

  const history = useHistory();

  function invitePlayer(username: string) {
    sendSocket("game-invite-event", { username });
    history.replace("/play");
    inviteUsernameSetter(username);
    gameActiveSetter(false);
    waitingForPlayerSetter(true);
    inviteFailedSetter(false);
  }

  return (
    <>
      <br /><br />
      <Container fluid>
        <Row>
          <Col xs={0} md={1} xl={2} >
            {(dataStore.onlineUsers !== undefined) && <>{dataStore.onlineUsers.map((user: any) => {
              return (<div key={user.username}>
                <Card>
                  <Card.Body>
                    <Image style={{ height: "25px" }} src={user.image} roundedCircle /> {user.username}
                    {(user.dev) &&
                      <Badge style={{ marginLeft: "5px" }} pill variant="info">DEV</Badge>
                    }
                    <div style={{ height: "10px" }} />
                    <Button onClick={() => { invitePlayer(user.username) }} style={{ display: "block", width: "100%" }} variant="info">invite</Button>
                  </Card.Body>
                </Card>
                <br />
              </div>)
            })}</>}
          </Col>
          <Col xs={12} md={10} xl={8} >
            <h1 className="text-info">play against other player</h1>
            <br />
          </Col>
          <Col xs={0} md={1} xl={2} />
        </Row>
      </Container>
    </>
  );
}
